// SCRIPT FOR CONVERTING FROM CM TO INCH 
const unitConverter = document.getElementById('unitConverter');
const sizeTables = document.querySelectorAll('.product-size-table');

if (unitConverter) {

unitConverter.addEventListener('change', () => {
  const isInches = unitConverter.checked;

  sizeTables.forEach(table => {
    if (table.classList.contains('skip-conversion')) return;

    const rows = table.querySelectorAll('tr');

    rows.forEach(row => {
      const cells = row.querySelectorAll('td');

      cells.forEach((cell, index) => {
        if (index === 0) return;

        if (isInches && !cell.dataset.originalValue) {
          cell.dataset.originalValue = cell.textContent;
        }

        const originalValue = cell.dataset.originalValue || cell.textContent;

        if (isInches) {
                    const cmValues = originalValue.includes(' - ')
                        ? originalValue.split(' - ').map(value => parseFloat(value.replace(' cm', '')))
                        : [parseFloat(originalValue.replace(' cm', ''))];

                    if (cmValues.some(isNaN)) return; 

                    const inchValues = cmValues.map(cmValue => (cmValue * 0.393701));

                    const roundedInchValues = inchValues.map(inchValue => {
                        let rounded = (Math.round(inchValue * 4) / 4); 
                        if (rounded % 1 === 0) {
                            return rounded; 
                        } else if (rounded % 0.5 === 0) {
                            return rounded.toFixed(1); 
                        } else {
                            return rounded.toFixed(2); 
                        }
                    });

          cell.textContent = roundedInchValues.join(' - ') + '"';

        } else {
          cell.textContent = originalValue;
        }
      });
    });
  });
});
}